import React, { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import SupportRequestPage from './components/SupportRequestPage/SupportRequestPage';

const SupportFeature: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={path} exact>
        <SupportRequestPage />
      </Route>
    </Switch>
  );
};

export default SupportFeature;
